<router-outlet></router-outlet>
<app-loader></app-loader>
<app-toast aria-live="polite" aria-atomic="true"></app-toast>

